import styles from "./stats.module.scss";

const Stat = ({ number, description, link }) => {
  return (
    <div className={styles.Stat}>
      <div className={styles.Number}>{number}</div>
      <div className={styles.Content}>
        <div className={styles.Description}>{description}</div>
        <div className={styles.Source}>{link}</div>
      </div>
    </div>
  );
};

function Stats({ stats }) {
  return (
    <div className={styles.Stats}>
      {stats.map((stat, index) => (
        <Stat key={`index_${stat.number}_${index}`} {...stat} />
      ))}
    </div>
  );
}

export default Stats;
